(function ( $ ) {
    const trCalloutPadding = '0.625rem';
    $.fn.trCallout = function(calloutContent, type = 'warning') {
        const trs = $(this);
        if (trs.length === 0) return;
        if (trs[0].tagName !== 'TR') {
            console.error('trCallout can only run on a tr');
            return;
        }
        const showCallout = !!calloutContent;
        trs.each(function() {
            const tr = $(this);
            const uid = get_unique_id();
            tr.attr('id', uid);
            const firstTd = tr.find('td:visible:nth-child(1)');
            firstTd.removeAttr('style');
            tr.find('.callout.tr-callout').remove();

            if (!showCallout) return;

            const callout = $(`<div class="callout ${type} tr-callout" />`);
            const content = calloutContent.split('</p>').length > 1 ? calloutContent : `<p>${calloutContent}</p>`;
            callout.html(content);
            firstTd.append(callout);

            tr.css('position', 'relative');


            callout.css({
                position: 'absolute',
                left: trCalloutPadding,
                right: trCalloutPadding,
                bottom: trCalloutPadding,
                margin: 0,
            })


            const eventSelector = `tr-resize-${uid}`;
            $(window).on(`resize.${eventSelector}`, function() {
                // Stop listening to resizes when the element is away from the dom
                if ($(`#${uid}`).length === 0) {
                    $(window).off(`resize.${eventSelector}`);
                    return;
                }

                firstTd.removeAttr('style');

                const rect = tr[0].getBoundingClientRect();
                const trHeight = rect.height;

                const calloutRect = callout[0].getBoundingClientRect();
                const calloutHeight = calloutRect.height;
                firstTd.css({
                    height: `calc(${trHeight + calloutHeight}px + ${trCalloutPadding})`
                })

            })
            $(window).trigger(`resize.${eventSelector}`);
        })
        return this;
    }
}( jQuery ));
